import { Row, Col } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import './candidateTechProficiency.css';
import TechProficiencyIcon from '../../../../assets/images/technical proficiency.png';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons';
const CandidateTechnicalProficiencyPanel = ({ techproficiency, index, isEditing, isInModal = false, onFieldChange }) => {

  const { skill = '', rating = 0, keyProject = '' } = techproficiency || {};

  const calculatePercentage = (r) => {
    const validRating = Number(r);
    return isNaN(validRating) ? 0 : (validRating / 5) * 100;
  };

  if (isEditing && isInModal) {
    return (
      <div className="w-100">
        <div className="mb-2">
          <label className="form-label">Skill <span style={{ color: 'red' }}>*</span></label>
          <input
            style={{ boxShadow: 'none', border: '1px solid #ced4da' }}
            type="text"
            spellCheck='false'
            className="form-control"
            value={skill}
            placeholder="Skill"
            onChange={(e) => onFieldChange(index, 'skill', e.target.value)}
          />
        </div>
        <div className="mb-2">
          <label className="form-label">Rating<span style={{ color: 'red' }}>*</span></label>
          <select
            style={{ boxShadow: 'none', border: '1px solid #ced4da' }}
            className="form-select"
            value={rating || ''}
            onChange={(e) => onFieldChange(index, 'rating', Number(e.target.value))}
          >
            <option value="">Select</option>
            {[1, 2, 3, 4, 5].map((r) => (
              <option key={r} value={r}>
                {r}
              </option>
            ))}
          </select>
        </div>
      </div>
    );
  }

  return (
    <Row className="profile-technical-proficiency-item mt-2">
      <Col md={12}>
        <Row className="d-none d-md-flex align-items-center">
          <Col md={1} className="d-flex align-items-center">
            <div className="profile-technical-proficiency-item-icon">
              <img src={TechProficiencyIcon} alt="Tech Proficiency Icon" />
            </div>
          </Col>
          <Col md={8} className="d-flex align-items-center">
            <div className="profile-technical-proficiency-item-name">
              {isEditing ? (
                <input
                  style={{ boxShadow: 'none', border: '1px solid #ced4da' }}
                  type="text"
                  spellCheck='false'
                  className="form-control d-inline w-auto me-2"
                  value={skill}
                  placeholder="Skill"
                  onChange={(e) => onFieldChange(index, 'skill', e.target.value)}
                />
              ) : (
                skill || '-'
              )}
            </div>
          </Col>
          <Col md={3} className="d-flex justify-content-end align-items-center">
            {isEditing ? (
              <select
                style={{ boxShadow: 'none', border: '1px solid #ced4da' }}
                className="form-select d-inline w-auto"
                value={rating || ''}
                onChange={(e) => onFieldChange(index, 'rating', Number(e.target.value))}
              >
                <option value="">Select</option>

                {[1, 2, 3, 4, 5].map((r) => (
                  <option key={r} value={r}>
                    {r}
                  </option>
                ))}
              </select>
            ) : (
              <div className="profile-technical-proficiency-item-percentage">
                {calculatePercentage(rating)}%
              </div>
            )}
          </Col>
        </Row>

        {/* Small Screen Layout */}
        <div className="d-md-none">
          <div className="d-flex align-items-center justify-content-between">
            <div className="profile-technical-proficiency-item-icon">
              <img src={TechProficiencyIcon} alt="Tech Proficiency Icon" />
            </div>
            <div className="profile-technical-proficiency-item-name">
              {isEditing ? (
                <input
                  style={{ boxShadow: 'none', border: '1px solid #ced4da' }}
                  type="text"
                  spellCheck='false'
                  className="form-control d-inline w-auto me-2"
                  value={skill}
                  placeholder="Skill"
                  onChange={(e) => onFieldChange(index, 'skill', e.target.value)}
                />
              ) : (
                skill || '-'
              )}
            </div>
            <div className="profile-technical-proficiency-item-percentage">
              {isEditing ? (
                <select
                  style={{ boxShadow: 'none', border: '1px solid #ced4da' }}
                  className="form-select d-inline w-auto"
                  value={rating || ''}
                  onChange={(e) => onFieldChange(index, 'rating', Number(e.target.value))}
                >
                  <option value="">Select</option>

                  {[1, 2, 3, 4, 5].map((r) => (
                    <option key={r} value={r}>
                      {r}
                    </option>
                  ))}
                </select>
              ) : (
                `${calculatePercentage(rating)}%`
              )}
            </div>
          </div>
        </div>
        <Row>
          <Col>
            <div className="profile-technical-proficiency-item-bar">
              <div
                className="profile-technical-proficiency-item-bar-fill"
                style={{
                  width: `${calculatePercentage(rating)}%`,
                }}
              ></div>
            </div>
          </Col>
        </Row>
      </Col>
    </Row>
  );
};

export default CandidateTechnicalProficiencyPanel;